import * as React from 'react';

import { useQuery } from '@apollo/client';
import ReportPQNormsQuery from '@graphql/queries/ReportPQNormsQuery';
import { Box } from '@mui/material';
import usePqTransform from 'hooks/usePqTransform';
import { useTranslation } from 'react-i18next';

import DataDownloadTile from '../DataDownloadTile';
import { TileType } from '../DataDownloadTile/DataDownloadTile';

interface Props {
  reportId: string;
}

const PQNormsDataDownload: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { reportId } = props;
  const pq = usePqTransform();

  const { loading, error, data } = useQuery<reports.ReportPQNormsResponse>(
    ReportPQNormsQuery,
    {
      variables: {
        reportID: reportId,
      },
    },
  );

  const categoryNorms = `${t('reports.summary.categoryNorms')}`;
  const stackRankNorms = `${t('reports.summary.stackRankNorms')}`;

  const csvData = (norms: reports.ReportPQNormsResponse) => {
    return norms.allRpStackrankNorms.nodes
      .map((n) => ({
        'Norm Type': stackRankNorms,
        '25th Percentile': pq.format(n.q1),
        '50th Percentile': pq.format(n.median),
        '75th Percentile': pq.format(n.q3),
      }))
      .concat(
        norms.allRpCategoryNorms.nodes.map((n) => ({
          'Norm Type': categoryNorms,
          '25th Percentile': pq.format(n.q1),
          '50th Percentile': pq.format(n.median),
          '75th Percentile': pq.format(n.q3),
        })),
      );
  };

  if (loading || error || csvData(data).length == 0) {
    return <Box />;
  }

  return (
    <DataDownloadTile
      tileType={TileType.CSV}
      headers={[
        'Norm Type',
        '25th Percentile',
        '50th Percentile',
        '75th Percentile',
      ]}
      csvDataRows={csvData(data)}
      fileName={`${pq.label}Norms.csv`}
      tileName={`${pq.label} Norms`}
    />
  );
};
export default PQNormsDataDownload;
